import React from 'react';
import classNames from 'classnames';
import tinycolor from 'tinycolor2';

type PillProps = {
  text?: string;
  icon?: React.ReactNode;
  color?: React.CSSProperties['color'];
  className?: string;
};

const Pill: React.FC<PillProps> = ({ text, icon, color = 'gray', className }) => {
  const textColour = tinycolor(color).isDark() ? 'white' : undefined;
  const pillClass = classNames('visualise-pill', className);
  return (
    <span
      className={pillClass}
      style={{ '--pill-color': color, '--pill-text-color': textColour } as React.CSSProperties}
    >
      {icon}
      {text}
    </span>
  );
};

export default Pill;
